import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { TextFormat } from 'react-jhipster';
import { Link, useParams } from 'react-router';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './catalogo-institucion.reducer';

export const CatalogoInstitucionDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id!));
  }, []);

  const catalogoInstitucionEntity = useAppSelector(state => state.catalogoInstitucion.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="catalogoInstitucionDetailsHeading">Catalogo Institucion</h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">ID</span>
          </dt>
          <dd>{catalogoInstitucionEntity.id}</dd>
          <dt>
            <span id="claveInstitucion">Clave Institucion</span>
          </dt>
          <dd>{catalogoInstitucionEntity.claveInstitucion}</dd>
          <dt>
            <span id="nombreCorto">Nombre Corto</span>
          </dt>
          <dd>{catalogoInstitucionEntity.nombreCorto}</dd>
          <dt>
            <span id="createdDate">Created Date</span>
          </dt>
          <dd>
            {catalogoInstitucionEntity.createdDate ? (
              <TextFormat value={catalogoInstitucionEntity.createdDate} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
        </dl>
        <Button as={Link as any} to="/catalogo-institucion" replace variant="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" /> <span className="d-none d-md-inline">Back</span>
        </Button>
        &nbsp;
        <Button as={Link as any} to={`/catalogo-institucion/${catalogoInstitucionEntity.id}/edit`} replace variant="primary">
          <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
        </Button>
      </Col>
    </Row>
  );
};

export default CatalogoInstitucionDetail;
